import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {findParentTags} from '../../../../../helpers/models/tagHelpers';
import {makeMapStateToProps, wrapInShallowSelector} from '../../../../../helpers/reselectHelpers';
import {TagModel} from '../../../../../models/api/tagModel';
import {AppState} from '../../../../../store/appState';
import {getHasPermission} from '../../../../../store/data/access/accessSelectors';
import {getTags} from '../../../../../store/data/tags/tagsSelectors';
import {
  getFlatActiveOrPendingTeammates,
  getUserId,
} from '../../../../../store/data/teammates/teammatesSelectors';
import {ActivityTagPill} from './activityTagPill';

/*
 * Props.
 */

interface ConversationHeaderTagPillContainerProps {
  tag: TagModel;
}

/*
 * Selectors.
 */

function getTag(_state: AppState, props: ConversationHeaderTagPillContainerProps) {
  return props.tag;
}

function makeGetTagsPath() {
  return createSelector([getTags, getTag], (tags, tag) => [tag, ...findParentTags(tags, tag)]);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationHeaderTagPillContainerProps>()(() => ({
  userId: getUserId,
  tagsPath: wrapInShallowSelector(makeGetTagsPath()),
  teammates: getFlatActiveOrPendingTeammates,
  hasPermission: getHasPermission,
}));

export const ActivityTagPillContainer = connect(mapStateToProps)(ActivityTagPill);
